import React from 'react';
import { Button, Alert, Box } from '@mui/material';
import { useZendesk } from 'contexts/ZendeskProvider';
import { SUPPORT_PHONE_NUMBER } from 'types/constants';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';

type AvailabilityCheckAlertProps = {
    message?: string
    onContactSupport?: (channel: 'web-chat' | 'phone') => void
}

const AvailabilityCheckAlert: React.FC<AvailabilityCheckAlertProps> = ({ 
    message = 'Reach out to us if you want to check nurse availability on particular days.',
    onContactSupport,
}) => {
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
    const { openZendesk } = useZendesk()

    // Defined once and shared by the desktop and mobile branches below.
    const messageUs = () => {
        onContactSupport?.('web-chat')
        openZendesk()
    }
    const callUs = () => onContactSupport?.('phone')
    
    if (isDesktop) {
        return (
            <Alert 
                severity='info'
                action={
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button size='small' variant='contained' color='primary' onClick={messageUs}>
                    Message us
                    </Button>
                    <Button size='small' variant='contained' color='primary' component='a' href={`tel:${SUPPORT_PHONE_NUMBER}`} onClick={callUs}>
                    Call us
                    </Button>
                </Box>
                }
            >
                {message}
            </Alert>
        )  
    } else {
        return (
            <Alert severity='info'>
                {message} <br />
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button size='small' variant='text' color='primary' onClick={messageUs}>
                    Message us
                    </Button>
                    <Button size='small' variant='text' color='primary' component='a' href={`tel:${SUPPORT_PHONE_NUMBER}`} onClick={callUs}>
                    Call us
                    </Button>
                </Box>
            </Alert>
        )
    }
    
};

export default AvailabilityCheckAlert;